const autoNgTemplateLoaderTemplate1 = require('./multi-registry-select.html');

export const multiRegistrySelect = {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller: 'multiRegistrySelectController',
  controllerAs: '$ctrl',
  bindings: {
    options: '<',
    value: '<',
    onChange: '=',
    label: '@',
    placeholder: '@',
    emptyText: '@',
    inputId: '@',
    dataCy: '@',
    tooltip: '@',
  },
};
